module.exports = __webpack_public_path__ + "img/stickers_0007_flag.e9803cbd.png";